export default "__VITE_ASSET__BS3Owyur__"